export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 120 },
  // { key: '2', headerName: 'Department ID', field: 'id', hide: false, width: 200 },
  { key: '3', headerName: 'Department', field: 'name', hide: false, width: 400 },
  { key: '4', headerName: 'Status', field: 'status', hide: false, width: 600 },
];
